import { paginationSliceKey, PaginationState } from './pagination-slice.config';
import { createFeatureSelector } from '@ngrx/store';

export const selectPaginationFeature = createFeatureSelector<PaginationState>(paginationSliceKey);
